export const SOLANA_TOKEN_ADDRESS_MAX_LENGTH = 44;
export const SOLANA_TOKEN_ADDRESS_MIN_LENGTH = 32;

export const PAGINATION_LIST = [
    5, 10, 15, 25, 50, 100
]

export const VIEW_BY_LAST_TIMES = [
    { name: "last_hour", label: "Last hour", value: 1 }, 
    { name: "last_6_hours", label: "Last 6 hours", value: 6 },
    { name: "last_12_hours", label: "Last 12 hours", value: 12 },
    { name: "last_24_hours", label: "Last 24 hours", value: 24 }
];

export const VIEW_BY_VOLUMES_RANGES = [
    { name: "volume_all", label: "All Volume", value: 100 }, 
    { name: "volume_100K", label: "Volume > 100K", value: 100_000 }, 
    { name: "volume_500K", label: "Volume > 500K", value: 500_000 },
    { name: "volume_1M", label: "Volume > 1M", value: 1_000_000 },
    { name: "volume_5M", label: "Volume > 5M", value: 5_000_000 }
];

export const SEARCH_BY_TIME_LIST = [
    { name: "1_day", label: "1 day", value: 1 }, 
    { name: "3_day", label: "3 days", value: 3 },
    { name: "week", label: "1 week", value: 7 },
    { name: "month", label: "1 month", value: 30 }
];

export const DEATH_COLOUR = "#b71c1c";
export const DANGEROUS_COLOUR = "#f44336";
export const WARNING_COLOUR = "#ff9800";
export const FRESH_COLOUR = "#4caf50";
export const LIGHTER_COLOUR = "#76ff03";

export const TRADINGVIEW_CONFIGS_SUB_PATH = "/tradingview/auto-trade/configs";
export const TRADINGVIEW_TRANSACTIONS_SUB_PATH = "/tradingview/auto-trade/transactions";

